export default {
  watch: {
    $route() {
      this.addViewTags()
    }
  },
  methods: {
    generateRoute() {
      if (this.$route.name) {
        return this.$route
      }
      return false
    },
    addViewTags() {
      const route = this.generateRoute()
      if (!route) {
        return false
      }
      this.$store.dispatch('addVisitedViews', route)
    }
  },
  mounted() {
    this.addViewTags()
  }
}
